import { render, staticRenderFns } from "./Inspection-Link.vue?vue&type=template&id=045fdbf3&scoped=true&"
import script from "./Inspection-Link.vue?vue&type=script&lang=js&"
export * from "./Inspection-Link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045fdbf3",
  null
  
)

export default component.exports